<template>
  <div class="info-container" v-if="checkInfo?.length">
    <div class="info-list">
      <InfoTit class="tit-info">审核意见</InfoTit>
      <div class="info-content" v-for="(item, index) in checkInfo" :key="index">
        <div class="item-tit">{{ item.reviewedOrg?item.reviewedOrg+`意见（${item.memberName?item.memberName:''}）`:''}}：</div>
        <div class="item-text">{{ item.opinionContent }}</div>
        <div style="display:flex">
          <div class="item-tit" v-if="item.postAuditSeal?.length">盖章资料:
          </div>
          <ComFileList :list="item.postAuditSeal" isDownload />
        </div>
        <!-- <div class="item-tit">审核时间：<span class="item-text">{{ item.updateTime }}</span></div> -->
        <div class="item-tit" v-if="!isDeadlineValid(item.deadline)">时限要求：<span class="item-text">{{
          item.deadline }}前修改</span></div>
        <!-- <div class="item-result"><a-icon class="item-icon" type="check-circle" theme="filled" />审核通过</div> -->
        <div v-if="item.auditResult === 0" class="item-result"><a-icon class="item-icon" type="check-circle"
            theme="filled" />已通过</div>
        <div v-if="item.auditResult === 2" class="item-result item-err"><a-icon class="item-icon" type="left-circle" theme="filled" />返回修改</div>
        <div v-if="item.auditResult === 1" class="item-result item-error"><a-icon class="item-icon"
            type="close-circle" theme="filled" />未通过</div>
        <div class="item-tit" v-if="item.attachment">附件：
          <a v-for="(item1, index) in parseFn(item.attachment)" :href="ctxPath + item1.url" :download="item1.fileName"
            class="item-text" :key="index">{{ item1.fileName }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfoTit from '@/components/tit/info-tit.vue'
import ComFileList from '@/components/common/com-file-list.vue'
import { _ctxPath } from '@/api/http'

export default {
  components: {
    InfoTit,
    ComFileList
  },
  props: ['checkInfo'],
  data() {
    return {
      ctxPath: _ctxPath
    }
  },
  methods: {
    parseFn(item) {
      return JSON.parse(item)
    },
    // 过滤无效修改时限
    isDeadlineValid(deadline) {
      return deadline.startsWith('9999')
    }
  }
}
</script>

<style lang="less" scoped>
.info-container {
  padding: 20px 191px 0 32px;
  background-color: #fff;
}

.tit-info {
  margin-bottom: 16px;
}

.info-content {
  // margin-top: 16px;
  padding-bottom: 10px;
  padding-left: 36px;
  position: relative;
  overflow: hidden;
  font-size: 14px;

  &:last-child {
    padding-bottom: 0;
  }

  &::before {
    content: "";
    position: absolute;
    left: 23px;
    top: 10px;
    height: 100%;
    width: 1px;
    background-color: #F2F4F8;
  }

  &::after {
    content: "";
    position: absolute;
    left: 20px;
    top: 7px;
    z-index: 2;
    width: 7px;
    height: 7px;
    background-color: #28B84A;
    border-radius: 100%;
  }

  .item-tit {
    color: #505D6E;
    line-height: 22px;
    margin-bottom: 4px;
  }

  .item-text {
    line-height: 22px;
    margin-bottom: 4px;
  }

  .item-result {
    color: #3DB273;
    line-height: 22px;

    .item-icon {
      margin-right: 6px;
      font-size: 16px;
      line-height: 22px;
    }
  }

  .item-err {
    // color: rgb(225, 58, 58);
    color: #F39F04;
  }
  .item-error{
    color: #E13A3A;
  }
}</style>
